import * as React from 'react';
import { connect } from 'react-redux';
import * as Components from '../../../components/index';
import * as Models from '../../../models/index';
import * as ActionCreators from '../../../actions/action.creators';
import classnames from 'classnames';

interface StateProps {
	password: string;
	confirm: string;
	userPwdValidationResult: Models.ValidateUserPassword_Response_Client[];
	reseted: boolean;
	processing: boolean;
}
interface DispatchProps {
	changePwd(value: string, isPwd?: boolean): any;
	validateUserPassword(): any;
	resetPwd(): any;
	setDefault(): any;
}
const mapStateToProps = (state: Models.StoreState): StateProps => ({
	confirm: state.pwdSecurity.confirmPassword,
	password: state.pwdSecurity.password,
	reseted: state.pwdRecovery.reseted,
	processing: state.shell.processing,
	userPwdValidationResult: state.pwdValidate.userPwdValidationResult,
});
const mapDispatchToProps = (dispatch: any): DispatchProps => ({
	changePwd: (value: string, isPwd: boolean) => dispatch(ActionCreators.PwdSecurity.changePassword(value, isPwd)),
	validateUserPassword: () => dispatch(ActionCreators.PwdValidate.validateUserPassword()),
	resetPwd: () => dispatch(ActionCreators.PwdRecovery.resetPassword()),
	setDefault: () => dispatch(ActionCreators.PwdSecurity.setDefault()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	class Component extends React.Component<StateProps & DispatchProps, any> {
		componentDidMount() {
			this.props.validateUserPassword();
		}

		componentWillUnmount() {
			this.props.setDefault();
		}

		render() {
			var testResults = this.props.userPwdValidationResult;
			var allTestPassed = testResults.filter(x => !x.isPassed).length === 0;
			return (
				<Components.LayoutBlock fill>
					<Components.LayoutBlock fill className='recovery-phase' align='center'>
						<Components.LayoutBlock inline={true} verticalAlign='center' className='inform-section'>
							<Components.Icon icon='lock' size='4' />
							<Components.Label className='recovery-label'>Please enter new password</Components.Label>
						</Components.LayoutBlock>
						<Components.LayoutBlock>
							<Components.Textbox
								maxLength={128}
								placeholder='New Password'
								type='password'
								value={this.props.password}
								onChange={value => this.props.changePwd(value, true)}
								onChanged={this.props.validateUserPassword}
							/>
							<Components.Textbox
								maxLength={128}
								placeholder='Confirm'
								type='password'
								value={this.props.confirm}
								onChange={value => this.props.changePwd(value)}
								onChanged={this.props.validateUserPassword}
							/>
						</Components.LayoutBlock>
						<Components.ListBox
							height='160px'
							name='Please create a password that meets the following requirements'
							items={testResults}
							listItemStyle='text-result'
						/>
					</Components.LayoutBlock>
					<Components.LayoutBlock>
						<Components.Button
							busy={this.props.processing}
							className={classnames({ disabled: !allTestPassed })}
							onClick={this.props.resetPwd.bind(this)}
						>
							Change
						</Components.Button>
						<Components.Button onClick={() => (window.location.hash = '/')}>To Login</Components.Button>
					</Components.LayoutBlock>
				</Components.LayoutBlock>
			);
		}
	}
);
